module.exports = __webpack_public_path__ + "static/big-planet-bg-e9a729aa6566199cc242d70a7aeeecd6.png";